import { render } from "./TheProjectsModal.vue?vue&type=template&id=22138da2&scoped=true&ts=true"
import script from "./TheProjectsModal.vue?vue&type=script&lang=ts"
export * from "./TheProjectsModal.vue?vue&type=script&lang=ts"

import "./TheProjectsModal.vue?vue&type=style&index=0&id=22138da2&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22138da2"]])

export default __exports__